import { authGuard } from '@abp/ng.core';
import { Routes } from '@angular/router';
export const APP_ROUTES: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'establishments' },
  {
    path: 'synchronization',
    loadComponent: () =>
      import('./main/synchronization/synchronization.component').then(
        c => c.SynchronizationComponent
      ),
    canActivate: [authGuard],
  },
  {
    path: 'establishments',
    loadComponent: () =>
      import('./main/establishments/establishments.component').then(c => c.EstablishmentsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'stands',
    loadComponent: () => import('./main/stands/stands.component').then(c => c.StandsComponent),
    canActivate: [authGuard],
  },
  {
    path: 'calibrations',
    loadComponent: () =>
      import('./main/calibrations/calibrations-information/calibrations').then(c => c.Calibrations),
    canActivate: [authGuard],
  },
  {
    path: 'calibration/:calibrationId',
    loadComponent: () =>
      import('./main/calibrations/calibration-calculation/calibration').then(c => c.Calibration),
    canActivate: [authGuard],
  },
  {
    path: 'calibrations/create-from-last/:calibrationId',
    loadComponent: () =>
      import(
        './main/calibrations/create-calibration-from-last/create-calibration-from-last'
      ).then(c => c.CreateCalibrationFromLast),
    canActivate: [authGuard],
  },
  {
    path: 'calibrations/incomplete-calibration-details/:calibrationId',
    loadComponent: () =>
      import(
        './main/calibrations/incomplete-calibration-details/incomplete-calibration-details'
      ).then(c => c.IncompleteCalibrationDetails),
  },
  {
    path: 'calibration-details/:calibrationId',
    loadComponent: () =>
      import('./main/calibrations/calibration-details/calibration-details').then(
        c => c.CalibrationDetails
      ),
    canActivate: [authGuard],
  },
  {
    path: 'account',
    loadChildren: () => import('@volo/abp.ng.account/public').then(c => c.createRoutes()),
  },
  {
    path: 'identity',
    loadChildren: () => import('@volo/abp.ng.identity').then(c => c.createRoutes()),
  },
  {
    path: 'language-management',
    loadChildren: () => import('@volo/abp.ng.language-management').then(c => c.createRoutes()),
  },
  {
    path: 'saas',
    loadChildren: () => import('@volo/abp.ng.saas').then(c => c.createRoutes()),
  },
  {
    path: 'audit-logs',
    loadChildren: () => import('@volo/abp.ng.audit-logging').then(c => c.createRoutes()),
  },
  {
    path: 'setting-management',
    loadChildren: () => import('@abp/ng.setting-management').then(c => c.createRoutes()),
  },
  {
    path: 'calibration-history',
    loadComponent: () =>
      import('./main/calibration-history/calibration-history').then(c => c.CalibrationHistory),
    canActivate: [authGuard],
  },
  {
    path: 'confirm-calibration/:id',
    loadComponent: () => import('./main/calibrations/components/calibration-confirm/calibration-confirm').then(c => c.CalibrationConfirm),
  },
  {
    path: 'send-calibration/:id',
    loadComponent: () => import('./main/calibrations/components/calibration-send/calibration-send').then(c => c.CalibrationSend)
  }
];
